import React from 'react';
import {connect} from 'react-redux';
import {Button, Dropdown} from 'semantic-ui-react';
import {createResourcePageItemsSelector} from "../../resources/selectors";
import {breakImagesPageName} from "../../pages/EditBreak/utils";
import {generateImagesAction, uploadOriginalAndGenerateImagesAction} from "../../pages/Images/actions";
import {isNoU} from "../../utils/DBUtils";
import {FormattedMessage} from "react-intl";

const getPageItems = createResourcePageItemsSelector(breakImagesPageName);

class AutoGenerateDesignImagesButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedImage: ""
    }
  }

  get possibleImages() {
    let uploadItem = {
      value: "",
      text: "None"
    };

    let items = (this.props.possibleImages || []).map((image) => ({
      value: image.id,
      text: image.name
    }));

    items.unshift(uploadItem);

    return items;
  }

  updateSelection = (event, data) => {
    this.setState({
      selectedImage: data.value
    })
  };

  onClick = () => {
    this.props.onClick(this.state.selectedImage)
  };

  render() {
    return (
      <div>
        <p>
          <FormattedMessage id="editbreak.design.generateDesignImages"/>
        </p>
        <Dropdown options={this.possibleImages}
                  value={this.state.selectedImage}
                  selection
                  disabled={this.props.generating}
                  placeholder={"None"}
                  onChange={this.updateSelection}/>
        <div>
          <Button className={'auto-generate-design-button blue'}
                  disabled={this.props.generating}
                  loading={this.props.generating}
                  onClick={this.onClick}>
            <FormattedMessage id={`editbreak.design.${this.state.selectedImage !== "" ? "generate" : "generateAndUpload"}`}/>
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    possibleImages: getPageItems(state.resources),
    generating: state.images.generatingImages
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  let breakId = ownProps.formProxy.currentBaseResource.id;
  return {
    onClick: (originalImageId) => {
      let args = [
        breakId,
        originalImageId,
        ['cardTrending', 'featured', 'socialShare', 'heroCard'],
        ['cardImageId', 'featuredImageId', 'socialShareBadgeId', 'heroImageId']
      ];

      if (isNoU(originalImageId) || originalImageId === "") {
        dispatch(uploadOriginalAndGenerateImagesAction(...args))
      } else {
        dispatch(generateImagesAction(...args));
      }
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoGenerateDesignImagesButton);



// WEBPACK FOOTER //
// ./public/components/images/AutoGenerateDesignImagesButton.jsx